import * as React from "react";
export class PaginationItem extends React.Component {
    render() {
        return (React.createElement("button", { type: "button", className: "rj-superbanner__pagination-item", "data-page-current": this.props.isCurrent, "data-page-id": this.props.id, onClick: this.props.handler, "data-uat": "button-superbanner-pagination-item" }));
    }
}
//# sourceMappingURL=PaginationItem.js.map